import { render, staticRenderFns } from "./DetailFolder.vue?vue&type=template&id=5587b15f&scoped=true"
import script from "./DetailFolder.vue?vue&type=script&lang=js"
export * from "./DetailFolder.vue?vue&type=script&lang=js"
import style0 from "./DetailFolder.vue?vue&type=style&index=0&id=5587b15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5587b15f",
  null
  
)

export default component.exports